import { z } from "zod";

export const subscriptionSettingsSchema = z.object({
  // positive, not nonnegative: an emptied price used to save as 0 and quietly
  // make the subscription free.
  priceSemiannual: z.number().positive("Iznos mora biti veći od 0.").optional(),
  priceAnnual: z.number().positive("Iznos mora biti veći od 0.").optional(),
  currency: z.string().min(1).max(8).optional(),
  vatRate: z.number().min(0).max(1).optional(),
  vatIncluded: z.boolean().optional(),
  paymentLinkTtlHours: z.number().int().min(1).max(720).optional(),
  renewalReminderDays: z.number().int().min(0).max(90).optional(),
  maxRemindersPerRun: z.number().int().min(0).max(1000).optional(),
  issuer: z
    .object({
      businessName: z.string().max(200).optional(),
      businessAddress: z.string().max(400).optional(),
      taxId: z.string().max(20).optional(),
      vatId: z.string().max(20).optional(),
      iban: z.string().max(40).optional(),
      bankName: z.string().max(200).optional(),
    })
    .optional(),
});

export const generatePaymentLinkSchema = z.object({
  planType: z.enum(["semiannual", "annual"]).optional(),
  ttlHours: z.number().int().min(1).max(720).optional(),
  sendEmail: z.boolean().optional().default(true),
  notes: z.string().max(500).optional(),
});

export const manualSubscriptionSchema = z
  .object({
    planType: z.enum(["semiannual", "annual", "custom"]),
    startsAt: z.string().min(8),
    expiresAt: z.string().min(8).optional(),
    amountGross: z.number().nonnegative(),
    vatRate: z.number().min(0).max(1),
    vatIncluded: z.boolean(),
    notes: z.string().min(1).max(1000),
    generatePdfReceipt: z.boolean().optional().default(false),
  })
  .refine((d) => d.planType !== "custom" || !!d.expiresAt, {
    message: "Datum isteka je obavezan za ručni (custom) plan",
    path: ["expiresAt"],
  })
  // Without this a mistyped year ("2025" for "2026") silently creates a
  // completed ledger row, burns a receipt number and emails a PDF for a
  // subscription that is already expired the moment it is written.
  .refine(
    (d) =>
      d.planType !== "custom" ||
      !d.expiresAt ||
      new Date(d.expiresAt).getTime() > new Date(d.startsAt).getTime(),
    {
      message: "Datum isteka mora biti poslije datuma početka",
      path: ["expiresAt"],
    }
  );

export const markBankTransferPaidSchema = z.object({
  paidAt: z.string().min(8),
  externalId: z.string().max(100).optional(),
  notes: z.string().max(500).optional(),
});

export const cancelBankTransferSchema = z.object({
  reason: z.string().min(1).max(500),
});

export const refundSubscriptionSchema = z.object({
  reason: z.string().min(1).max(500),
});

export const subscriptionExemptSchema = z.object({
  exempt: z.boolean(),
});
